import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminSearchInsights = lazy(() => import("@/pages/admin/AdminSearchInsights"));

export const Route = createFileRoute("/admin/sokinsikter")({
  component: () => <AdminSearchInsights />,
});
